"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgContact(props) {
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M33.297 26.36l-3.347-3.344a2.346 2.346 0 00-3.348 0l-2.677 2.675c-3.883-1.873-7.766-5.75-9.507-9.628l2.544-2.675c.938-.936.938-2.407 0-3.21l-3.347-3.476a2.346 2.346 0 00-3.347 0L6.92 10.179c-5.758 5.75 17.138 28.75 23.029 22.866l3.347-3.343a2.339 2.339 0 000-3.343z", stroke: "currentColor", strokeWidth: 2 }, void 0) }), void 0));
}
exports.default = SvgContact;
//# sourceMappingURL=Contact.js.map